module.exports = __webpack_public_path__ + "img/file-binary.9faad8b0.svg";